import "./pages.css";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CheckoutRoute } from "./CheckoutRoute";
import { PaymentRoute } from "./PaymentRoute";
import { OrderReceiptRoute } from "./OrderReceiptRoute";
import { CartProvider } from "@/contexts/CartContext";
import { PageProvider } from "@/contexts/PageContext";
import { Toaster } from "@/components/ui/sonner";

const elem = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <PageProvider>
        <CartProvider>
          <Routes>
            <Route path="/checkout/:checkoutId/:step?" element={<CheckoutRoute />} />
            <Route path="/payments/:id" element={<PaymentRoute />} />
            <Route path="/orders/:id" element={<OrderReceiptRoute />} />
          </Routes>
          <Toaster />
        </CartProvider>
      </PageProvider>
    </BrowserRouter>
  </HelmetProvider>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
